import { createBrowserRouter } from 'react-router-dom';

// project imports
import RouteErrorPage from 'components/RouteErrorPage';
import MainRoutes from './MainRoutes';
import LoginRoutes from './LoginRoutes';

// ==============================|| ROUTING RENDER ||============================== //

const router = createBrowserRouter(
  [
    { ...MainRoutes, errorElement: <RouteErrorPage /> },
    { ...LoginRoutes, errorElement: <RouteErrorPage /> }
  ],
  { basename: import.meta.env.VITE_APP_BASE_NAME }
);

export default router;
